import { d as c, g as s } from "../../chunks/config.DpwjsOs3.js";
const k = "emulation=support-console", d = "emulation=proxy", u = "||", r = {
  httpOnly: !0,
  secure: !0,
  sameSite: "lax",
  path: "/"
}, l = (o, t) => {
  const e = o.getHeader("Set-Cookie") || [];
  return Array.isArray(e) ? [...e, ...t] : [e.toString(), ...t];
}, m = () => {
  const o = /* @__PURE__ */ new Date();
  return o.setTime(o.getTime() + 15 * 60 * 1e3), "expires=" + o.toUTCString();
}, g = (o) => {
  const t = o.trim(), e = [k, t].join(u);
  document.cookie = e;
  const i = m();
  document.cookie = `${e};` + i + ";path=/";
}, h = () => {
  var t;
  if (typeof document > "u")
    return { isScEmulation: !1 };
  const o = document.cookie.split(";");
  for (let e = 0; e < o.length; e++) {
    const i = (t = o[e]) == null ? void 0 : t.trim();
    if (i != null && i.startsWith(k)) {
      const [, n] = i.split(u);
      return {
        isScEmulation: !0,
        agentId: n ?? "",
        cookie: i
      };
    }
  }
  return { isScEmulation: !1 };
}, y = (o) => {
  const t = `facilityCookieValue=${o}`, e = m();
  document.cookie = `${t};` + e + ";path=/";
}, A = (o) => {
  var n;
  const t = ((n = o == null ? void 0 : o.headers) == null ? void 0 : n.cookie) ?? "", e = Object.fromEntries(
    t.split(";").map((a) => {
      const [p, ...f] = a.trim().split("=");
      return [p, decodeURIComponent(f.join("="))];
    })
  );
  return (e == null ? void 0 : e.facilityCookieValue) ?? null;
}, S = () => {
  var e;
  const o = (e = h()) == null ? void 0 : e.cookie;
  if (!o) return;
  const t = "expires=" + (/* @__PURE__ */ new Date()).toUTCString();
  document.cookie = `${o};` + t + ";path=/";
}, x = (o, t) => {
  const e = o.trim(), i = t.trim(), n = [d, e, i].join(
    u
  );
  document.cookie = n;
  const a = m();
  document.cookie = `${n};` + a + ";path=/";
}, C = () => {
  var t;
  const o = document.cookie.split(";");
  for (let e = 0; e < o.length; e++) {
    const i = (t = o[e]) == null ? void 0 : t.trim();
    if (i != null && i.startsWith(d)) {
      const [, n, a] = i.split(u);
      return {
        isProxyEmulation: !0,
        actorId: n ?? "",
        actorName: a ?? "",
        cookie: i
      };
    }
  }
  return { isProxyEmulation: !1 };
}, I = () => {
  var e;
  const o = (e = C()) == null ? void 0 : e.cookie;
  if (!o) return;
  const t = "expires=" + (/* @__PURE__ */ new Date()).toUTCString();
  document.cookie = `${o};` + t + ";path=/";
}, M = () => {
  const { isProxyEmulation: o, actorId: t, actorName: e } = C();
  o && t && e && x(t, e);
}, O = ({
  mhoAuthId: o,
  mhoUsername: t,
  mhoId: e,
  res: i
}) => {
  const n = [
    c.serialize(s("CookieMhoToken"), o, r),
    c.serialize(s("CookieUsername"), t ?? "", r),
    c.serialize(s("CookieMhoId"), e, r)
  ];
  i.setHeader("Set-Cookie", l(i, n));
}, w = ({
  mhoAuthId: o,
  mhoUsername: t,
  mhoId: e,
  mhoActorId: i,
  res: n
}) => {
  const a = [
    c.serialize(s("CookieMhoToken"), o, r),
    c.serialize(s("CookieUsername"), t ?? "", r),
    c.serialize(s("CookieMhoId"), e, r),
    c.serialize(s("CookieMhoActorId"), i, r)
  ];
  n.setHeader("Set-Cookie", l(n, a));
};
function P(o) {
  const t = [
    c.serialize(s("CookieMhoActorId"), "", { ...r, maxAge: 0 })
  ];
  o.setHeader("Set-Cookie", l(o, t));
}
function T() {
  if (typeof document > "u" || typeof window > "u") return;
  const o = ["/", "/support-console", "/mho", "", void 0], t = [window.location.hostname, "." + window.location.hostname.replace(/^www\./, "")];
  for (const e of o) {
    document.cookie = `emulation=; Path=${e || "/"}; Max-Age=0;`;
    for (const i of t)
      document.cookie = `emulation=; Path=${e || "/"}; Domain=${i}; Max-Age=0;`;
  }
  document.cookie = "emulation=; Max-Age=0;";
}
export {
  P as clearProxyActorCookie,
  x as createEmulationCookieProxy,
  g as createEmulationCookieSC,
  y as createFacilityValueCookie,
  T as deleteEmulationCookieEverywhere,
  I as deleteEmulationCookieProxy,
  S as deleteEmulationCookieSC,
  C as getEmulationCookieProxy,
  h as getEmulationCookieSC,
  A as getFacilityValueCookie,
  M as refreshEmulationCookies,
  O as saveAuthCookies,
  w as saveAuthCookiesForProxy
};
